<form
  [formGroup]="formGroup"
  class="gw-flex gw-flex-col gw-gap-x-large"
  novalidate
>
  <div
    class="gw-grid gw-grid-cols-1 lg:gw-grid-cols-2 gw-gap-x-medium gw-gap-y-x-large"
  >
    <gatewee-input-v2
      [form]="formGroup"
      controlName="document"
      [label]="'features.onboarding.businessForm.labels.cnpj' | translate"
      type="text"
      id="business-document"
      mask="00.000.000/0000-00"
      [required]="true"
      (blur)="fetchCompanyData()"
    ></gatewee-input-v2>
    <gatewee-input-v2
      [form]="formGroup"
      controlName="name"
      [label]="'features.onboarding.businessForm.labels.legalName' | translate"
      type="text"
      id="business-name"
      [required]="true"
    ></gatewee-input-v2>
  </div>

  <div>
    <gatewee-select-v3
      [items]="companyTypes"
      label="{{
        'features.onboarding.steps.businessForm.inputs.companyType' | translate
      }}"
      [placeholder]="
        'features.onboarding.businessForm.placeholders.companyType' | translate
      "
      formControlName="companyType"
    ></gatewee-select-v3>
    <div
      class="gw-text-status-negative gw-text-sm gw-mt-x-small"
      *ngIf="
        formGroup.get('companyType')?.touched &&
        formGroup.get('companyType')?.invalid
      "
    >
      {{
        'features.onboarding.businessForm.validation.companyType' | translate
      }}
    </div>
  </div>

  <div
    class="gw-grid gw-grid-cols-1 lg:gw-grid-cols-2 gw-gap-x-medium gw-gap-y-x-large"
  >
    <gatewee-input-v2
      [form]="formGroup"
      controlName="displayName"
      [label]="
        'features.onboarding.businessForm.labels.displayName' | translate
      "
      type="text"
      id="business-displayName"
    ></gatewee-input-v2>
    <div>
      <gatewee-multi-select
        [items]="businessAreaItems"
        [formGroup]="formGroup"
        [label]="
          'features.onboarding.businessForm.labels.businessAreas' | translate
        "
        [placeholder]="
          'features.onboarding.businessForm.placeholders.businessAreas'
            | translate
        "
        formControlName="businessAreas"
      ></gatewee-multi-select>

      <div
        class="gw-text-status-negative gw-text-sm gw-mt-x-small"
        *ngIf="
          formGroup.get('businessAreas')?.touched &&
          formGroup.get('businessAreas')?.invalid
        "
      >
        {{
          'features.onboarding.businessForm.validation.businessAreas'
            | translate
        }}
      </div>
    </div>
  </div>
</form>
